'use strict';

import { decodeHtml, getVueTemplate } from '../../../_imports/utils/utils.common';
import BaseVueComponent from '../../../_imports/shared/base-vue-component.vue.common';
import CallToAction from '../../../cta/cta.vue';

export default {
    template: getVueTemplate('video-idle-message'),
    mixins: [
        BaseVueComponent,
    ],
    components: {
        CallToAction
    },
    data() {
        return {
            isVisible: false,
        }
    },
    computed: {
        title() {
            return decodeHtml(this?.data?.title);
        },
        text() {
            return decodeHtml(this?.data?.text);
        },
        callToActions() {
            return this?.data?.callToActions;
        }
    },
    methods: {
        hasCallToActions() {
            return this.callToActions?.length;
        }
    }
};